import "../styles/pages.scss";
import backgroud from "../assets/img/dataPage1_1.png";
import { useEffect, useState } from "react";

export function DataPage1() {
    const [state, setState] = useState("inActive");
    useEffect(() => {
        setState("active");
    }, []);
    return (
        <div className="page">
            <img className="pageBackground" src={backgroud} />
            <div className="pageTop dataPage1"></div>
            <div className={"left " + state}>
                <div className="mainText">For foreign tourists</div>
                <div className="subText">10-day program </div>
                <table>
                    <tr>
                        <td>Pick up from the international airport</td>
                        <td>1 Day</td>
                    </tr>
                    <tr className="tableInner">
                        <td>Accommodation at IBIS hotel</td>
                        <td>2 Day</td>
                    </tr>
                    <tr className="tableInner">
                        <td>Take a special flight to Kamp</td>
                        <td>3 Day</td>
                    </tr>
                    <tr className="tableInner">
                        <td>Start a camping trip</td>
                        <td>4-8 Days</td>
                    </tr>
                    <tr className="tableInner">
                        <td>Return to Ulaanbaatar </td>
                        <td>9 Day</td>
                    </tr>
                    <tr className="tableInner">
                        <td>Delivery to international airport</td>
                        <td>10 Day</td>
                    </tr>
                </table>
            </div>
            <div className={"right " + state}>
                <div className="title">About the trip</div>
                <div className="text">
                    When you come to our camp, located in a beautiful natural
                    setting at the confluence of the Tengis-Shishged rivers, you
                    will admire the wild and pristine nature and enjoy catching
                    the rare Tul fish, Zeveg and Hadran fish.
                </div>
            </div>
        </div>
    );
}
